import request from '../../utils/request';
import { Result } from '../../models/general';
import type {
    InternalMovementView,
    InternalMovementInput,
    InternalMovementUpdateInput,
    MovementTaskView,
    MovementTaskInput,
    UpdateTaskStatusInput,
    EmployeeSelectionView,
    EmployeeMovementHistoryView,
    RejectMovementInput,
    DepartmentSelectionView,
} from '../../models/employee';

export async function getInternalMovements(): Promise<Result<InternalMovementView[]>> {
    const response = await request.get<Result<InternalMovementView[]>>('InternalMovement/GetAll');
    return response.data;
}

export async function getInternalMovement(id: number): Promise<Result<InternalMovementView>> {
    const response = await request.get<Result<InternalMovementView>>(`InternalMovement/GetById/${id}`);
    return response.data;
}

export async function initiateMovement(input: InternalMovementInput): Promise<Result<InternalMovementView>> {
    const response = await request.post<Result<InternalMovementView>>('InternalMovement/InitiateMovement', input);
    return response.data;
}

export async function updateMovement(id: number, input: InternalMovementUpdateInput): Promise<Result<InternalMovementView>> {
    const response = await request.put<Result<InternalMovementView>>(`InternalMovement/UpdateMovement/${id}`, input);
    return response.data;
}

export async function cancelMovement(id: number): Promise<Result<boolean>> {
    const response = await request.post<Result<boolean>>(`InternalMovement/CancelMovement/${id}`);
    return response.data;
}

export async function deleteMovement(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`InternalMovement/DeleteMovement/${id}`);
    return response.data;
}

export async function managerApproveMovement(id: number): Promise<Result<InternalMovementView>> {
    const response = await request.post<Result<InternalMovementView>>(`InternalMovement/ManagerApprove/${id}`);
    return response.data;
}

export async function hrApproveMovement(id: number): Promise<Result<InternalMovementView>> {
    const response = await request.post<Result<InternalMovementView>>(`InternalMovement/HrApprove/${id}`);
    return response.data;
}

export async function rejectMovement(id: number, input: RejectMovementInput): Promise<Result<InternalMovementView>> {
    const response = await request.post<Result<InternalMovementView>>(`InternalMovement/Reject/${id}`, input);
    return response.data;
}

export async function updateMovementTaskStatus(taskId: number, input: UpdateTaskStatusInput): Promise<Result<MovementTaskView>> {
    const response = await request.put<Result<MovementTaskView>>(`InternalMovement/UpdateTaskStatus/${taskId}`, input);
    return response.data;
}

export async function addMovementTask(movementId: number, input: MovementTaskInput): Promise<Result<MovementTaskView>> {
    const response = await request.post<Result<MovementTaskView>>(`InternalMovement/AddTask/${movementId}`, input);
    return response.data;
}

export async function removeMovementTask(taskId: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`InternalMovement/RemoveTask/${taskId}`);
    return response.data;
}

export async function getMovementEmployeeSelections(): Promise<Result<EmployeeSelectionView[]>> {
    const response = await request.get<Result<EmployeeSelectionView[]>>('InternalMovement/GetEmployeeSelections');
    return response.data;
}

export async function getMovementDepartments(): Promise<Result<DepartmentSelectionView[]>> {
    const response = await request.get<Result<DepartmentSelectionView[]>>('InternalMovement/GetDepartments');
    return response.data;
}

export async function applyMovement(id: number): Promise<Result<InternalMovementView>> {
    const response = await request.post<Result<InternalMovementView>>(`InternalMovement/Apply/${id}`);
    return response.data;
}

export async function getEmployeeMovementHistory(employeeId: string): Promise<Result<EmployeeMovementHistoryView[]>> {
    const response = await request.get<Result<EmployeeMovementHistoryView[]>>(`InternalMovement/GetEmployeeHistory/${employeeId}`);
    return response.data;
}
